module.exports = __webpack_public_path__ + "files/915f8cdb4fb2040cd9d9825de485dc2f.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/skintone-3.png
// module id = 1492
// module chunks = 60